import * as actions from './../actions/sessionActions';
import store from './../store/index';

let axios;
if (process.env.NODE_ENV === 'production') {
   axios = require('./axios.prod');
} else {
   axios = require('./axios.dev');
}

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.interceptors.request.use(function (config) {
   // Do something before request is sent
   const token = actions.getTokenFromSessionStorage();
   if (token) {
      config.headers['x-access-token'] = token;
   } else {
      delete config.headers['x-access-token'];
   }
   return config;
}, function (error) {
   // Do something with request error
   return Promise.reject(error);
});

// const store = configureStore();
//
axios.interceptors.response.use(function (response) {
   // Do something with response data
   return response;
}, function (error) {
   if (error && error.response && error.response.status === 403) {
      actions.removeTokenFromSessionStorage();
      store.dispatch(actions.removeUser());
   }
   // Do something with response error
   return Promise.reject(error);
});

export default axios;



/** WEBPACK FOOTER **
 ** ./src/constants/axios.js
 **/